import { styled, makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Container = styled(Box)({
  width: '100%',
});

export const FiltersRow = styled(Box)({
  display: 'flex',
  gap: '12px',
  marginBottom: '16px',
  flexWrap: 'wrap',
  alignItems: 'center',
});

export const useStyles = makeStyles(theme => ({
  tableContainer: {
    background: theme.colors.backgroundLight,
    borderRadius: theme.borderRadius,
    padding: '16px',
  },
  chipPaid: {
    backgroundColor: theme.colors.win,
    color: '#fff',
  },
  chipPending: {
    backgroundColor: theme.colors.primary,
    color: '#1E2141',
  },
  chipOverdue: {
    backgroundColor: theme.colors.loss,
    color: '#fff',
  },
  chipKiwify: {
    backgroundColor: '#7c4dff',
    color: '#fff',
  },
  chipManual: {
    backgroundColor: '#546e7a',
    color: '#fff',
  },
  filterField: {
    minWidth: '150px',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    minWidth: '400px',
  },
}));
